import ChangePassword from '../../components/Forms/ChangePassword';
import UpdateProfileForm from '../../components/Forms/UpdateProfileForm';
import './Profile.css';
import {useEffect, useState} from "react";

const UpdateProfile: React.FC = () => {
    const [isVisible, setVisible] = useState<boolean>(false);

    useEffect(() => {
        setVisible(true);
    }, []);

    return (
        <div className={`updateProfile ${isVisible ? 'visible' : ''}`}>
            <div className='updateProfileForm_container'>
                <UpdateProfileForm />
            </div>
            
            <div className='changePassword_continer'>
                <ChangePassword />
            </div>
        </div>
    )
};

export default UpdateProfile;